import React from "react";
import {
  MUIGrid,
  MUITypography,
  tokens,
  IconChanges,
  IconTime,
  IconWarningAlert,
} from "@cobee/cobee-ui";

const Label = ({
  children,
  backgroundColor,
}: {
  children: JSX.Element;
  backgroundColor: string;
}) => (
  <MUIGrid
    item
    alignItems="center"
    borderRadius="56px"
    display="flex"
    height="24px"
    width="fit-content"
    sx={{
      backgroundColor,
      padding: "2px 8px",
    }}
  >
    {children}
  </MUIGrid>
);

export const NoAmountLabel = ({ text }: { text: string }) => (
  <Label backgroundColor={tokens.palette.tag.warning}>
    <>
      <IconWarningAlert
        color={tokens.palette.grey["900"]}
        style={{ paddingRight: 8 }}
      />
      <MUITypography variant="body2" color={tokens.palette.grey["900"]}>
        {text}
      </MUITypography>
    </>
  </Label>
);

export const RenewalLabel = ({ text }: { text: string }) => (
  <Label backgroundColor={tokens.palette.grey["50"]}>
    <>
      <IconChanges
        color={tokens.palette.grey["900"]}
        style={{ paddingRight: 8 }}
      />
      <MUITypography variant="body2" color={tokens.palette.grey["900"]}>
        {text}
      </MUITypography>
    </>
  </Label>
);

export const ConsumableFromLabel = ({ text }: { text: string }) => (
  <Label backgroundColor={tokens.palette.tag.purple}>
    <>
      <IconTime
        color={tokens.palette.grey["900"]}
        style={{ paddingRight: 8 }}
      />
      <MUITypography
        variant="body2"
        color={tokens.palette.grey["900"]}
        sx={{ fontWeight: 500 }}
      >
        {text}
      </MUITypography>
    </>
  </Label>
);
